var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { shippingInstruction as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { useRequest } from '../../../hooks/requestHook';
import { column, numericColumn } from '../../../hooks/useColumns';
import MaterialTable from '../../MaterialTable';
import { packages } from '../../../constants/offerValues';
import { AddIcon } from '../../atoms/Icons';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import NewOfferForm from './NewOfferForm';
var ShippingInstructionItemsPage = function (_a) {
    var editable = _a.editable, shippingInstruction = _a.shippingInstruction, items = _a.items, onCreated = _a.onCreated, onUpdated = _a.onUpdated, onDeleted = _a.onDeleted;
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var updateItemApi = useRequest(api.updateItem);
    var deleteItemApi = useRequest(api.destroyItem);
    var notify = useNotify();
    var _c = React.useState(false), openNewOfferDialog = _c[0], setOpenNewOfferDialog = _c[1];
    var handleUpdate = React.useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateItemApi({
                            id: item.id,
                            shipping_instruction_item: {
                                lot_number: item.lotNumber,
                                lot_ref: item.lotRef,
                                product_name: item.productName,
                                bag_size: item.bagSize,
                                quantity: item.quantity,
                                net_weight: item.netWeight,
                                package: item.package,
                                fob_price: item.fobPrice,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    onUpdated(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateItemApi, onUpdated]);
    var columns = React.useMemo(function () { return [
        column('lotNumber', { cellStyle: redColorIf(isBlank) }),
        column('lotRef'),
        column('productName', { cellStyle: redColorIf(isBlank) }),
        numericColumn('bagSize'),
        column('package', { lookup: packages }),
        numericColumn('quantity'),
        numericColumn('netWeight'),
        numericColumn('fobPrice'),
        numericColumn('totalPrice', { editable: 'never' }),
    ]; }, []);
    var actions = React.useMemo(function () { return [
        {
            icon: function () { return React.createElement(AddIcon, null); },
            onClick: function () { return setOpenNewOfferDialog(true); },
            isFreeAction: true,
            disabled: !editable,
        },
    ]; }, [editable]);
    var handleCreated = React.useCallback(function (item) {
        onCreated(item);
        setOpenNewOfferDialog(false);
    }, [onCreated]);
    var handleDelete = React.useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, deleteItemApi({ id: item.id })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    onDeleted(response);
                    notify('success', [t('messages.deleteSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [deleteItemApi, onDeleted, t, notify]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MaterialTable, { title: "CONTENTS", model: "shippingInstructionItem", isLoading: loading, actions: actions, columns: columns, data: items, emptyValue: "(blank)", editable: {
                onRowUpdate: editable ? handleUpdate : undefined,
                onRowDelete: editable ? handleDelete : undefined,
            }, options: {
                sorting: false,
                paging: false,
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
            } }),
        React.createElement(FullScreenDialog, { open: openNewOfferDialog, title: "new offer", onClose: function () { return setOpenNewOfferDialog(false); } },
            React.createElement(NewOfferForm, { shippingInstruction: shippingInstruction, onCreated: handleCreated }))));
};
export default ShippingInstructionItemsPage;
var redColorIf = function (condition) {
    return function (value, item) {
        if (!item)
            return {};
        if (condition(value)) {
            return { color: 'red' };
        }
        return {};
    };
};
var isBlank = function (value) { return !value; };
